<form [formGroup]="searchForm" (submit)="applyFilters()">
    <div class="row gx-3 gy-2 align-items-end">
      <div class="col-auto">
        <label for="search-input" class="form-label">{{'documents.searchTextLabel' | transloco}}</label>
        <div class="input-with-icon-prepend input-with-icon-append">
          <i class="icon icon-search prepend"></i>
          <input id="search-text" class="form-control" type="search"
                 [placeholder]="'documents.searchPlaceholder' | transloco"
                 [formControl]="searchForm.searchText"
          />
          <i class="icon icon-search-close hover-grow append" [ngClass]="searchForm.searchText?.value?.length ? 'cursor-pointer': 'opacity-0'"
             (click)="clearSearchText()"></i>
        </div>
      </div>

      <div class="col-auto">
        <label class="form-label" for="status">{{ 'general.status' | transloco }}</label>
        <app-multiselect id="status" [counterOnly]="true" [enableCheckAll]="false" [data]="statusMultiselectData"></app-multiselect>
      </div>

      <div class="col-auto">
        <label for="period" class="form-label">
          {{ 'documents.searchPeriod.label' | transloco }}
        </label>
        <select class="form-control dropdown-select" id="period"
                [formControl]="periodControl" (change)="updatePeriod()">
          <option value="0">{{ 'documents.searchPeriod.today' | transloco }}</option>
          <option value="7">{{ 'documents.searchPeriod.lastSevenDays' | transloco }}</option>
          <option selected value="31">{{ 'documents.searchPeriod.lastMonth' | transloco }}</option>
          <option value="93">{{ 'documents.searchPeriod.lastThreeMonths' | transloco }}</option>
          <option value="365">{{ 'documents.searchPeriod.lastYear' | transloco }}</option>
          <option value="">{{ 'documents.searchPeriod.all' | transloco }}</option>
        </select>
      </div>

      <div class="col-auto d-flex gap-3">
        <button class="button-secondary d-flex gap-2 position-relative" type="button" (click)="toggleAdvancedFilters()" [disabled]="loading">
          <fa-icon class="text" [icon]="filterIcon" size="lg"></fa-icon>
          {{'action.filter' | transloco}}
          <span *ngIf="searchForm.getNumberOfAdvancedFilters()" class="text-danger">
            / {{searchForm.getNumberOfAdvancedFilters ()}}
          </span>
        </button>

        <button [ngClass]="searchForm.getTotalNumberOfFilters() ? 'button-secondary-warning' : 'button-secondary'" type="button"
                (click)="clearFilters()" [disabled]="!searchForm.getTotalNumberOfFilters() || loading">
          {{ 'action.clearAll' | transloco }}
        </button>

        <app-save-button [isLoading]="loading">
          {{ 'action.search' | transloco }}
        </app-save-button>
      </div>
    </div>

    <div class="row gx-3 gy-1 align-items-end"
         *ngIf="viewSettings.filters$ | async as filters"
         [ngbCollapse]="!filtersExpanded">
      <div class="col-12 my-2">
        <div ngbDropdown>
          <button type="button" class="button-tertiary" ngbDropdownToggle>
            {{ 'documents.viewSettings.showFilters.action' | transloco }}
          </button>
          <div ngbDropdownMenu class="dropdown-menu-large">
            <div class="row pb-2">
              <div class="col-lg-6">
                <h3 class="font-weight-bold my-2">{{ 'documents.viewSettings.showFilters.sections.roles' | transloco }}</h3>
                <app-displayable-item [item]="filters.client"
                                      (itemChanged)="filters.client=$event;filtersChanged(filters)"></app-displayable-item>
                <app-displayable-item [item]="filters.consignor"
                                      (itemChanged)="filters.consignor=$event;filtersChanged(filters)"></app-displayable-item>
                <app-displayable-item [item]="filters.consignee"
                                      (itemChanged)="filters.consignee=$event;filtersChanged(filters)"></app-displayable-item>
                <app-displayable-item [item]="filters.carrier"
                                      (itemChanged)="filters.carrier=$event;filtersChanged(filters)"></app-displayable-item>
                <app-displayable-item [item]="filters.vehicle"
                                      (itemChanged)="filters.vehicle=$event;filtersChanged(filters)"></app-displayable-item>
              </div>

              <div class="col-lg-6">
                <h3 class="font-weight-bold my-2">{{ 'documents.viewSettings.showFilters.sections.others' | transloco }}</h3>
                <app-displayable-item [item]="filters.orderNumber"
                                      (itemChanged)="filters.orderNumber=$event;filtersChanged(filters)"></app-displayable-item>
                <app-displayable-item [item]="filters.reference"
                                      (itemChanged)="filters.reference=$event;filtersChanged(filters)"></app-displayable-item>
                <app-displayable-item [item]="filters.withObservations"
                                      (itemChanged)="filters.withObservations=$event;filtersChanged(filters)"></app-displayable-item>
                <app-displayable-item [item]="filters.signedBy"
                                      (itemChanged)="filters.signedBy=$event;filtersChanged(filters)"></app-displayable-item>
              </div>

              <div class="col-lg-6">
                <h3 class="font-weight-bold my-2">{{ 'documents.viewSettings.showFilters.sections.dates' | transloco }}</h3>
                <app-displayable-item [item]="filters.establishedDate"
                                      (itemChanged)="filters.establishedDate=$event;filtersChanged(filters)"></app-displayable-item>
                <app-displayable-item [item]="filters.actualDeliveryDate"
                                      (itemChanged)="filters.actualDeliveryDate=$event;filtersChanged(filters)"></app-displayable-item>
              </div>

              <div class="col-lg-6">
                <h3 class="font-weight-bold my-2">{{ 'documents.viewSettings.showFilters.sections.goods' | transloco }}</h3>
                <app-displayable-item [item]="filters.withModifiedGoods"
                                      (itemChanged)="filters.withModifiedGoods=$event;filtersChanged(filters)"></app-displayable-item>
                <app-displayable-item [item]="filters.withRtis"
                                      (itemChanged)="filters.withRtis=$event;filtersChanged(filters)"></app-displayable-item>
                <app-displayable-item [item]="filters.flags"
                                      (itemChanged)="filters.flags=$event;filtersChanged(filters)"></app-displayable-item>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3" *ngIf="filters.orderNumber.isDisplayed">
        <label class="form-label" for="order-number">{{ 'freightDocument.orderNumber' | transloco }}</label>
        <input [formControl]="searchForm.orderNumber" type="text" class="form-control" id="order-number" name="order-number">
      </div>

      <div class="col-lg-3" *ngIf="filters.reference.isDisplayed">
        <label class="form-label" for="reference">{{ 'transport.reference' | transloco }}</label>
        <input [formControl]="searchForm.reference" type="text" class="form-control" id="reference" name="reference">
      </div>

      <div class="col-lg-3" *ngIf="filters.establishedDate.isDisplayed">
        <label class="form-label" for="established-date">{{ 'freightDocument.establishedDate' | transloco }}</label>
        <app-date-period-inputs [form]="searchForm.establishedTimeWindow">
        </app-date-period-inputs>
      </div>

      <div class="col-lg-3" *ngIf="filters.actualDeliveryDate.isDisplayed">
        <label class="form-label" for="actual-delivery-date">{{ 'freightDocument.deliveryDateActual' | transloco }}</label>
        <app-date-period-inputs [form]="searchForm.deliveryTimeWindow">
        </app-date-period-inputs>
      </div>

      <div class="col-lg-3" *ngIf="filters.client.isDisplayed">
        <label class="form-label" for="client">{{ 'role.client' | transloco }}</label>
        <app-type-ahead-input name="client" [control]="searchForm.client" inputContainerClass=""
                              containerClass=""></app-type-ahead-input>
      </div>
      <div class="col-lg-3" *ngIf="filters.consignor.isDisplayed">
        <label class="form-label" for="consignor">{{ 'role.consignor' | transloco }}</label>
        <app-type-ahead-input name="consignor" [control]="searchForm.consignor" inputContainerClass=""
                              containerClass=""></app-type-ahead-input>
      </div>
      <div class="col-lg-3" *ngIf="filters.consignee.isDisplayed">
        <label class="form-label" for="consignee">{{ 'role.consignee' | transloco }}</label>
        <app-type-ahead-input name="consignee" [control]="searchForm.consignee" inputContainerClass=""
                              containerClass=""></app-type-ahead-input>
      </div>
      <div class="col-lg-3" *ngIf="filters.carrier.isDisplayed">
        <label class="form-label" for="carrier">{{ 'role.carrier' | transloco }}</label>
        <app-type-ahead-input name="carrier" [control]="searchForm.carrier" inputContainerClass=""
                              containerClass=""></app-type-ahead-input>
      </div>
      <div class="col-lg-3" *ngIf="filters.vehicle.isDisplayed">
        <label class="form-label" for="vehicle">{{ 'vehicle.label' | transloco }}</label>
        <app-type-ahead-input name="vehicle" [control]="searchForm.vehicle" inputContainerClass=""
                              containerClass=""></app-type-ahead-input>
      </div>

      <div class="col-lg-3" *ngIf="filters.signedBy.isDisplayed">
        <label class="form-label" for="signedBy">{{ 'freightDocument.signedBy' | transloco }}</label>
        <input [formControl]="searchForm.signedBy" type="text" class="form-control" id="signedBy" name="signedBy">
      </div>

      <ng-container *ngIf="filters.flags.isDisplayed || searchForm.withFlags.value || searchForm.withoutFlags.value">
        <div class="col-lg-3">
          <label class="form-label">{{ 'freightDocument.filter.withFlags' | transloco }}</label>
          <app-multiselect [data]="withFlagsMultiselectData" [badgeLimit]="2" [enableCheckAll]="false" [translateLabels]="false"></app-multiselect>
        </div>
        <div class="col-lg-3">
          <label class="form-label">{{ 'freightDocument.filter.withoutFlags' | transloco }}</label>
          <app-multiselect [data]="withoutFlagsMultiselectData" [badgeLimit]="2" [enableCheckAll]="false" [translateLabels]="false"></app-multiselect>
        </div>
      </ng-container>

      <div class="col-lg-3" *ngIf="filters.withRtis.isDisplayed">
        <label for="withOrWithoutRtis" class="form-label">{{ 'freightDocument.filter.withRtis' | transloco }}</label>
        <select class="form-control dropdown-select" id="withOrWithoutRtis" [formControl]="searchForm.withOrWithoutRtis">
          <option selected value=""></option>
          <option [value]="true">{{ 'freightDocument.filter.withRtisYes' | transloco }}</option>
          <option [value]="false">{{ 'freightDocument.filter.withRtisNo' | transloco }}</option>
        </select>
      </div>

      <div class="col-lg-3 d-flex align-items-center pt-2" *ngIf="filters.withModifiedGoods.isDisplayed">
        <app-switch-input label="freightDocument.filter.withGoodsAdjusted"
                          [labelAfter]="true"
                          [small]="false"
                          [control]="searchForm.withGoodsAdjusted">
        </app-switch-input>
      </div>

      <div class="col-12" *ngIf="filters.withObservations.isDisplayed">
        <app-search-with-observations [form]="searchForm.withObservation"
                                      [eventSelectedItems]="observationEvents$ | async"
                                      [importanceSelectedItems]="observationImportance$ | async">
        </app-search-with-observations>
      </div>

    </div>
</form>
